import React from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import DataSnapshotIcon from "../../../assets/img/dataSnapshot.png";
import ExportIcon from "../../../assets/img/export.png";
import ImportIcon from "../../../assets/img/fileImport.png";

type Props = {
  onImport: () => void;
  onExport: () => void;
  onSnapshot: () => void;

  // loaders (optional)
  snapshotLoading?: boolean;
  exportLoading?: boolean;
  importLoading?: boolean;
};

const CodeHeaderActions: React.FC<Props> = ({
  onImport,
  onExport,
  onSnapshot,
  snapshotLoading = false,
  exportLoading = false,
  importLoading = false,
}) => {
  const { t } = useTranslation("docProcessingCodes");
  return (
    <div className="codeHeaderActions">
      <Button
        onClick={onImport}
        loading={importLoading}
        disabled={importLoading || exportLoading || snapshotLoading}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          fontFamily: "Poppins",
          fontSize: "14px",
          backgroundColor: "white",
          border: "1px solid #4A1C96",
          borderRadius: "8px",
          height: "44px",
          color: "#4A1C96",
        }}
      >
        <img
          src={ImportIcon}
          alt={t("codeHeaderActions.importAlt")}
          style={{ width: "16px", height: "16px" }}
        />
        {t("codeHeaderActions.import")}
      </Button>

      <Button
        onClick={onExport}
        loading={exportLoading}
        disabled={exportLoading || importLoading || snapshotLoading}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          fontFamily: "Poppins",
          fontSize: "14px",
          backgroundColor: "#4A1C96",
          border: "1px solid #4A1C96",
          borderRadius: "8px",
          height: "44px",
          color: "#FFFFFF",
        }}
      >
        <img
          src={ExportIcon}
          alt={t("codeHeaderActions.exportAlt")}
          style={{ width: "16px", height: "16px" }}
        />
        {t("codeHeaderActions.export")}
      </Button>

      <Button
        className="dataSnapshotButton"
        onClick={onSnapshot}
        loading={snapshotLoading}
        disabled={snapshotLoading || importLoading || exportLoading}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          fontFamily: "Poppins",
          fontSize: "14px",
          backgroundColor: "#A072EB",
          border: "1px solid #A072EB",
          borderRadius: "8px",
          color: "#FFFFFF",
          height: "44px",
        }}
      >
        {!snapshotLoading && (
          <img
            src={DataSnapshotIcon}
            alt={t("codeHeaderActions.dataSnapshotAlt")}
            style={{ width: "16px", height: "16px" }}
          />
        )}
        {t("codeHeaderActions.dataSnapshot")}
      </Button>
    </div>
  );
};

export default CodeHeaderActions;
